export const PRIMARY_AXIS_COLOR = "#FF8A00";
export const SECONDARY_AXIS_COLOR = "#0048FF";
